import { equals } from 'ramda'
import { useLocation, useNavigate } from 'react-router-dom'
import { makeQueryString } from '../url'
import { useSearchParams } from './useSearchParams'

type SearchParams = Record<string, string>

export const useModifySearchParam = () => {
  const search = useSearchParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()

  return (searchObj: Partial<SearchParams>) => {
    const newSearch = { ...search, ...searchObj }

    if (!equals(search, newSearch)) {
      const url = `${pathname}${makeQueryString(newSearch)}`
      navigate(url, { replace: true })
    }
  }
}
